import { render, staticRenderFns } from "./WalletForm.vue?vue&type=template&id=4ee57438&scoped=true&"
import script from "./WalletForm.vue?vue&type=script&lang=js&"
export * from "./WalletForm.vue?vue&type=script&lang=js&"
import style0 from "./WalletForm.vue?vue&type=style&index=0&id=4ee57438&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee57438",
  null
  
)

export default component.exports